const storyContentTypes = {
    MEDIA: 'MEDIA',
    QUIZ: 'QUIZ',
    FEED: 'FEED',
};

export default storyContentTypes;
